<button class="button-header-ghost" [nbTooltip]="tooltip" nbButton ghost onclick="this.blur();" (click)="onButtonClicked()">
  <app-icon class="{{currentAnimationComponent}}" [status]="status" [icon]="icon"></app-icon>
</button>
